import { Home, SearchX } from "lucide-react";
import { Link, useLocation } from "react-router-dom";

export function NotFoundPage() {
  const location = useLocation();

  return (
    <div className="mx-auto flex min-h-[calc(100vh-8rem)] max-w-3xl items-center justify-center px-2 py-10">
      <section className="w-full rounded-lg border border-slate-200 bg-white p-6 shadow-sm dark:border-slate-800 dark:bg-slate-900 md:p-8">
        <div className="mb-5 flex h-12 w-12 items-center justify-center rounded-lg bg-blue-50 text-blue-600 dark:bg-blue-950/60 dark:text-blue-300">
          <SearchX size={24} strokeWidth={2} aria-hidden="true" />
        </div>
        <p className="mb-2 text-sm font-semibold uppercase tracking-wide text-blue-600 dark:text-blue-300">
          Page not found
        </p>
        <h1 className="text-2xl font-semibold text-slate-950 dark:text-white">
          This Hub route does not exist.
        </h1>
        <p className="mt-3 text-sm text-slate-600 dark:text-slate-300">
          The requested path is not registered in Hub:{" "}
          <span className="font-mono text-slate-800 dark:text-slate-100">
            {location.pathname}
          </span>
        </p>
        <div className="mt-6">
          <Link
            to="/"
            className="inline-flex items-center gap-2 rounded-lg bg-blue-600 px-4 py-2 text-sm font-semibold text-white shadow-sm transition-colors hover:bg-blue-700"
          >
            <Home size={16} strokeWidth={2} aria-hidden="true" />
            Hub home
          </Link>
        </div>
      </section>
    </div>
  );
}
